import React, { useEffect } from 'react';
import { UpdateUserInput, UserFragment } from '../../../generated/graphql';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid } from '@mui/material';
import { FormInput } from '../../../components/form-input';
import { useForm, Controller } from 'react-hook-form';

interface EditProfileDialogProps {
  user: UserFragment;
  onUpdate: (update: UpdateUserInput) => void;
  onClose: () => void;
  open: boolean;
}

interface EditProfileFormFields {
  fullName?: string | null;
  phone?: string | null;
  email: string;
}

export function EditProfileDialog(props: EditProfileDialogProps) {
  const { user, onUpdate, open, onClose } = props;

  const { control, handleSubmit, reset } = useForm<EditProfileFormFields>({
    defaultValues: { fullName: user.fullName, phone: user.phone, email: user.email },
  });

  useEffect(() => {
    reset({ fullName: user.fullName, phone: user.phone, email: user.email });
  }, [open, user, reset]);

  const onSubmit = (data: EditProfileFormFields) => {
    onUpdate({ fullName: data.fullName ?? '', phone: data.phone, email: data.email });
    onClose();
  };

  if (!user) {
    return null;
  }

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md">
      <DialogTitle>Profil</DialogTitle>

      <DialogContent>
        <Grid container key={user.id} spacing={1}>
          <Grid size={{ xs: 12, sm: 4, lg: 4 }}>
            <Controller
              name="fullName"
              control={control}
              render={({ field, fieldState }) => (
                <FormInput
                  label="Celé meno"
                  value={field.value ?? ''}
                  onChange={field.onChange}
                  errorText={fieldState.error?.message}
                />
              )}
            />
          </Grid>
          <Grid size={{ xs: 12, sm: 5, lg: 5 }}>
            <Controller
              name="phone"
              control={control}
              render={({ field, fieldState }) => (
                <FormInput
                  label="Telefón"
                  value={field.value ?? ''}
                  onChange={field.onChange}
                  errorText={fieldState.error?.message}
                />
              )}
            />
          </Grid>
          <Grid size={{ xs: 12, sm: 5, lg: 5 }}>
            <Controller
              name="email"
              control={control}
              render={({ field, fieldState }) => (
                <FormInput
                  label="E-mail"
                  value={field.value ?? ''}
                  onChange={field.onChange}
                  errorText={fieldState.error?.message}
                />
              )}
            />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Zatvoriť</Button>
        <Button type="submit" variant="contained" onClick={handleSubmit(onSubmit)}>
          Uložiť
        </Button>
      </DialogActions>
    </Dialog>
  );
}
